import { useaxios } from "../../../../utils/useaxios";
export default (text) => employDispatch => {
    useaxios('employ/activesearch.php', { text }).then((res) => {
        if (res.status == "ok") {
            employDispatch({ type: 'setactivesearch', payload: res.employ });
        } else {
            // clear();
        }
    });
}